import React from 'react';
import Bg from '../../background/Bg';

import { useAuth } from '../../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
    const {auth, setAuth} = useAuth()
    const navigate = useNavigate()

    function handleTryOut(){
        if(!auth.role || !auth.id){
            navigate('/login')
        }else{
            navigate('/dashboard')
        }
    }
    return (
        <section className="relative flex flex-col items-center justify-center min-h-[50vh] bg-base-200 overflow-hidden">
            <Bg />
            <div className="max-w-5xl px-4 text-center absolute z-[10]">
                <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight bg-gradient-to-r from-indigo-600 to-indigo-400 bg-clip-text text-transparent">
                    Discover Your Perfect Learning Path
                </h1>
                
                <p className="mt-4 md:mt-6 text-base sm:text-lg md:text-xl max-w-2xl mx-auto font-bold ">
                    Enter a topic and get a personalized roadmap based on expert evaluations to guide your learning journey.
                </p>
                
                <div className="mt-6 sm:mt-8">
                    <button className="btn btn-primary btn-sm md:btn-md lg:btn-lg font-medium" onClick={() => handleTryOut()}>
                        Try it out
                    </button>
                </div>
            </div>
        </section>
    );
}
